import { createContext } from 'react';
import { createStore } from 'zustand';
import { devtools } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';

export interface OrganizationProps {
  organizationId?: string | null;
  createdTime?: Date;
  documentRetentionInDays?: number;
  monthlyNumberOfPagePredictionsAllowed?: number;
  monthlyNumberOfPagePredictionsUsed?: number;
  name?: string | null;
  numberOfAgentsAllowed?: number;
  numberOfAgentsCreated?: number;
  numberOfUsersAllowed?: number;
  numberOfUsersCreated?: number;
  paymentMethodId?: string | null;
  picture?: Blob | null;
  pictureUrl?: string | null;
  planId?: string | null;
  url?: string | null;
}

export interface OrganizationState extends OrganizationProps {
  update: (updates: Partial<OrganizationProps>) => void;
}

export const createOrganizationStore = (initProps?: Partial<OrganizationProps>) => {
  return createStore<OrganizationState>()(
    devtools(
      immer((set) => ({
        ...initProps,
        update: (updates) =>
          set((state) => {
            if (updates.name) {
              state.name = updates.name;
            }
            if (updates.planId) {
              state.planId = updates.planId;
            }
            if (updates.paymentMethodId) {
              state.paymentMethodId = updates.paymentMethodId;
            }
            if (updates.picture) {
              state.picture = updates.picture;
            }
            if (updates.url) {
              state.url = updates.url;
            }
            if (updates.createdTime) {
              state.createdTime = updates.createdTime;
            }
            if (updates.documentRetentionInDays) {
              state.documentRetentionInDays = updates.documentRetentionInDays;
            }
          }),
      }))
    )
  );
};

export type OrganizationStore = ReturnType<typeof createOrganizationStore>;

export const OrganizationContext = createContext<OrganizationStore | null>(null);
